import type { ITheme } from '@visactor/vchart';
import { semiDesignDark } from '@visactor/vchart-semi-theme';

export const ttPlatformDark: ITheme = {
  ...semiDesignDark,
  name: 'ttPlatformDark',
  description: 'TT Platform - dark',
  type: 'dark'
};
